import { render, staticRenderFns } from "./placeholderBox.vue?vue&type=template&id=c2c52a44&scoped=true&"
import script from "./placeholderBox.vue?vue&type=script&lang=js&"
export * from "./placeholderBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2c52a44",
  null
  
)

export default component.exports